<template>
  <Entity :type="localUser.type" :size="size">
    <template slot="title">
      <ListInline divided>
        <li v-if="number" class="text-bold">
          <slot :number="number" name="number">
            {{ number }}
          </slot>
        </li>
        <li v-if="entityname">
          <span class="text-bold">
            <slot :entityname="entityname" name="entityname">
              {{ entityname }}
            </slot>
          </span>
        </li>
        <li v-else class="text-muted">
          {{ nameFallback }}
        </li>
        <li v-if="layout === 'inline' && company" class="text-normal">
          <slot :company="company" name="company">
            {{ company }}
          </slot>
        </li>
      </ListInline>
    </template>
    <template slot="body">
      <template v-if="layout === 'stacked'">
        <template v-if="line">
          <slot :line="line" name="line">
            {{ $t('users.line-number', { line }) }}
          </slot>
        </template>
        <template v-else-if="company">
          <slot :company="company" name="company">
            {{ company }}
          </slot>
        </template>
      </template>
      <slot name="body" />
    </template>
    <template slot="actions">
      <slot name="actions" />
    </template>
  </Entity>
</template>

<script>
import Entity from '@/components/ui/Entity';

export default {
  components: {
    Entity,
  },

  props: {
    user: {
      type: Object,
      default: null,
    },
    username: {
      type: String,
      default: '',
    },
    /**
     * The entity size:
     * `large`
     */
    size: {
      type: String,
      default: null,
    },
    /**
     * The entity layout
     * stacked: display line number (bus) or company name (external) below the entity name
     * inline: display only company name between parenthesis next to the entity name
     * none: do not display line number nor company name anywhere
     */
    layout: {
      type: String,
      default: 'stacked',
    },
  },

  computed: {
    localUser() {
      return (
        this.user ||
        this.$store.getters['users/getUserByUsername'](this.username) ||
        {}
      );
    },

    entityname() {
      if (
        this.localUser.type === 'bus' &&
        this.localUser.details &&
        this.localUser.details.current_course
      ) {
        const {
          driver_first_name,
          driver_last_name,
          driver_matricule,
        } = this.localUser.details.current_course;
        const driver_matricule_str = driver_matricule
          ? ` (${driver_matricule})`
          : '';
        return `${driver_first_name} ${driver_last_name}${driver_matricule_str}`.trim();
      } else if (
        this.localUser.type === 'inspector' &&
        this.localUser.details &&
        this.localUser.details.matricule
      ) {
        const { first_name, last_name } = this.localUser;
        const { matricule } = this.localUser.details;
        return `${first_name} ${last_name} (${matricule})`.trim();
      } else {
        const { first_name, last_name } = this.localUser;
        return `${first_name} ${last_name}`.trim();
      }
    },

    company() {
      return this.localUser.details ? this.localUser.details.company : null;
    },

    number() {
      return (
        (this.localUser.details && this.localUser.details.vehicle_no) || null
      );
    },

    nameFallback() {
      if (this.localUser.type === 'bus') {
        return this.$t('users.statuses.not-in-course');
      } else {
        return this.$t('users.statuses.unknown');
      }
    },

    line() {
      return (
        this.localUser.details.current_course &&
        this.localUser.details.current_course.line
      );
    },
  },
};
</script>
